export default "__VITE_ASSET__1f9ec5K6__"